import { useState, useEffect } from 'react';
import { useToast, useParams, getScreenType } from '@web3/base-hooks';
import { bybitHecate, appPath } from '@web3/base-utils';
import { isApp } from '@/utils/common';
import {
  getBbSolAirdropActivity,
  getAirdropActivityStatus,
} from '@/services/bbysol';
import { AirdropActivity } from '@/types/bbsol';

export default function useAirdropActivity(activityCode: string) {
  const [activity, setActivityFn] = useState<AirdropActivity>();
  //
  const setActivity = (object) => {
    if (!object) {
      setActivityFn(null);
      return;
    }
    setActivityFn({
      activityCode,
      ...object,
      status: getAirdropActivityStatus(
        object?.startTime,
        object?.endTime,
        object?.currentTime
      ),
    });
  };
  //
  const { toastWarn } = useToast();
  // 获取活动数据
  const fetchData = async () => {
    const { result, success, message } =
      await getBbSolAirdropActivity(activityCode);
    if (!success) {
      toastWarn(message);
      return;
    }
    setActivity(result);
  };
  //
  useEffect(() => {
    if (!activityCode) {
      toastWarn('need activityId');
      return;
    }
    fetchData();
  }, [activityCode]);
  //
  return {
    activity,
  };
}

// 跳转到质押池
export function usePool() {
  const { locale } = useParams();
  const { isMobile } = getScreenType();
  // 不能放到 hooks 里，因为 nextjs server 下 window 为空
  const allLinks = () => {
    const links = {
      web: `${window.location.origin}/${locale}${appPath}/pool/77`,
      app: `bybitapp://open/route?targetUrl=${encodeURIComponent('by-mini://web3_applet/earn/stake/sol_lst')}`,
      mobileWeb: '',
    };
    //
    const link = `https://app.bybit.com/inapp?by_dp=${encodeURIComponent(links.app)}&by_web_link=${encodeURIComponent(links.web)}&force_redirect=true`;
    links.mobileWeb = link;
    return links;
  };

  const onJump = () => {
    const links = allLinks();
    if (isMobile) {
      if (isApp()) {
        bybitHecate('Router', 'push', {
          path: links.app,
        });
      } else {
        window.top?.open(links.mobileWeb);
      }
      return;
    }
    window.location.href = links.web;
  };
  //
  return {
    onJump,
    links: allLinks,
  };
}
